import React, { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import qs from "qs";

import FilterSidebar from "./filter-sidebar";
import ProductList from "./product-list";
import { getProducts } from "./shop-section.service";
import ShopTop from "./shop-top";
import { useLocation } from "react-router-dom";

export default function ShopSection() {
  const [products, setProducts] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [page, setPage] = React.useState(1);
  const [limit] = React.useState(24);
  const [hasMore, setHasMore] = React.useState(true);

  const location = useLocation();
  const params = qs.parse(location.search, { ignoreQueryPrefix: true });

  const category: any = params.category;
  const search: any = params.search;
  const dimension: any = params.dimension;
  const side: any = params.side;
  const value: any = params.value;

  // Fetch products when category or dimensions change
  useEffect(() => {
    setProducts([]);
    setPage(2);
    getProducts({
      limit,
      page: 1,
      category,
      name: search,
      dimension,
      side,
      value,
    })
      .then((response) => {
        setProducts(response.data.results);
        setHasMore(response.data.results.length > 0);
      })
      .catch((err) => {
        setError(err.message);
      });
  }, [location.search]); // Trigger when category or dimensions change

  const fetchMoreProducts = () => {
    if (loading) return; // Prevent multiple concurrent API calls

    setLoading(true);

    getProducts({
      limit,
      page,
      category,
      name: search,
      dimension,
      side,
      value,
    })
      .then((response) => {
        setProducts((prevProducts) => [
          ...prevProducts,
          ...response.data.results,
        ]);
        setHasMore(response.data.results.length > 0);
        setPage((prevPage) => prevPage + 1);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };

  return (
    <section className="ec-page-content section-space-p">
      <div className="container">
        <div className="row">
          <FilterSidebar />
          <div className="ec-shop-rightside col-lg-9 order-lg-last col-md-12  margin-b-30">
            <ShopTop />
            <InfiniteScroll
              style={{ overflow: "unset" }}
              dataLength={products.length}
              next={fetchMoreProducts}
              hasMore={hasMore}
              loader={<p>Loading more products...</p>}
              endMessage={
                products.length === 0 ? <p>No more products to display</p> : ""
              }
            >
              <ProductList products={products} />
            </InfiniteScroll>
            {error && <div>Error: {error}</div>}
          </div>
        </div>
      </div>
    </section>
  );
}
